<app-header></app-header>

<section class="bg-grey reset-section-pad2 pb-0" *ngIf="isLoaded">

    <div class="container">

            <div class="row">
                <div class="col-lg-12 head-tit">
                    <h1 [innerHTML]="careers.careers_title"></h1>
                </div>   
            </div>

            <div class="row empleo-int-blq">

                <div class="col-lg-12 empleo-int-blq-inner-img">
                    <img class="img-full-cover" [src]="careers.careers_imgBigUrl" alt="{{careers.careers_imgBigAlt}}">
                    <div class="int-showcase__footer bg-grey"></div>
                    <h1 class="light fw-bold" [innerHTML]="careers.careers_heroTxt"></h1>
                </div>   
        

            </div>

            <div class="row">
                <div class="col-lg-12 mt-5">
                        <a routerLink="{{careers.careers_button_backLink}}" class="btn-more">{{careers.careers_button_backTxt}}<div class="icon uparrow"></div></a>

            </div>   
            </div>

    </div>

</section>
<ng-template #sinPosition>
  <section class="bg-grey">
    <div class="container text-center">
      <h3><strong>En estos momentos no hay ningún puesto vacante.</strong></h3>
    </div>
  </section>
</ng-template>

<div *ngIf="isPosition; else sinPosition">
<section id="empleo1" class="bg-grey" 
[class.bg-dark-grey]="i % 2 !== 0" [class.bg-grey]="i % 2 === 0"
*ngFor="let job of jobs; let i=index">

    <div class="container">

          <div class="row empleo-int-blq2">

              <div class="col-lg-12">
                   
                    <h1 class="" [innerHTML]="job.title"></h1>
                    <div class="divider-team bg-rco"></div>
               </div> 

               <div class="col-lg-12 mt-5">

                        <!-- Nav tabs -->
                            <ul class="nav nav-pills">
                              <li class="nav-item">
                                <a class="nav-link active" data-bs-toggle="tab" href="#acerca{{i}}">{{careers.careers_about_title}}</a>
                              </li>
                              <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="tab" href="#que-haras{{i}}">{{careers.careers_todo_title}}</a>
                              </li>
                              <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="tab" href="#requisitos{{i}}">{{careers.careers_reqs_title}}</a>
                              </li>
                            </ul>

                            <!-- Tab panes -->
                            <div class="tab-content p-0 mt-4">
                              <div class="tab-pane container active p-0" id="acerca{{i}}"
                              [innerHTML]="job.about">
                              </div>
                              <div class="tab-pane container fade p-0" id="que-haras{{i}}"
                              [innerHTML]="job.todo">
                              </div>
                              <div class="tab-pane container fade p-0" id="requisitos{{i}}"
                              [innerHTML]="job.reqs">
                              </div>
                           </div>


                            <div class="col-lg-12 mt-5 aviso-oferta-int">
                                
                                <h2 class="text-center fw-bold" [innerHTML]="careers.careers_claim"></h2>
                                <a class="btn btn-rco" href="{{job.linkedin_url}}" target="_blank"><p>{{careers.careers_button_Linkedin_txt}}</p></a>
                           </div> 

               </div>  
        

         </div>


    </div>

</section>
</div>


<app-footer-main></app-footer-main>
